<template>
  <v-group
    ref="item"
    :config="{
      x: packet.path[0][0],
      y: packet.path[0][1],
      width: PACKET_CONFIG.RADIUS * 2,
      height: PACKET_CONFIG.RADIUS * 2,
      listening: false,
    }"
  >
    <v-circle
      :config="{
        ...defaultPacketConfig,
      }"
    />
    <v-text :config="{
      x: PACKET_CONFIG.RADIUS,
      y: PACKET_CONFIG.RADIUS,
      text: `${packet.taskCount}`,
      fill: PACKET_CONFIG.COLOR.DEFAULT,
      align: 'right',
      verticalAlign: 'bottom',
      fontSize: 10,
    }" />
  </v-group>
</template>

<script>
import { PACKET_CONFIG } from '@/constants';

export default {
  name: 'PlaygroundPacket',
  props: {
    packet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      PACKET_CONFIG,
      defaultPacketConfig: {
        radius: PACKET_CONFIG.RADIUS,
        fill: PACKET_CONFIG.COLOR[this.packet.type] || PACKET_CONFIG.COLOR.DEFAULT,
      },
    };
  },
  mounted() {
    this.packet.setKonvaNode(this.$refs.item.getNode());
  },
};
</script>
